/**
 * Document entity model class
 *
 * This file is part of Minasa
 * (c) Kaden und Partner AG
 */
import BaseModel from './BaseModel';
import BaseCollection from './BaseCollection';

export class Document extends BaseModel {
    defaults() {
        return {
            // entity properties
            id: null,
            path: null,
            name: null,
            size: null,
            type: null,
            extension: null,
            readable_type: null,
        };
    }

    mutations() {
        return {
            id: (id) => (Number(id) > 0 ? Number(id) : null),
        };
    }

    entityName() {
        return 'Document';
    }
}

export class DocumentCollection extends BaseCollection {
    options() {
        return {
            model: Document,
        };
    }

    entityName() {
        return 'Document';
    }
}
